import React, { useState } from 'react';
import axios from 'axios';
import { Search as SearchIcon } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { ProductCard } from '../components/ProductCard';
import { API_URL } from '../lib/utils';

export const Search = () => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;

    setLoading(true);
    setSearched(true);
    try {
      const response = await axios.get(`${API_URL}/products?search=${query}`);
      setResults(response.data);
    } catch (error) {
      console.error('Search failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen py-12 px-6 lg:px-12 bg-purple-25" data-testid="search-page">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl mx-auto mb-12">
          <h1 className="text-4xl md:text-5xl font-heading font-light text-center mb-8" data-testid="search-title">
            Search Products
          </h1>

          <form onSubmit={handleSearch} className="flex gap-3" data-testid="search-form">
            <div className="flex-1 relative">
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-stone-400" />
              <Input
                type="text"
                placeholder="Search for products..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="pl-10"
                data-testid="search-input"
              />
            </div>
            <Button type="submit" className="rounded-full" data-testid="search-button">
              Search
            </Button>
          </form>
        </div>

        {/* Results */}
        {loading ? (
          <div className="text-center py-12" data-testid="loading">
            <p className="text-stone-500">Searching...</p>
          </div>
        ) : searched ? (
          results.length > 0 ? (
            <>
              <p className="text-stone-600 mb-8" data-testid="results-count">
                Found {results.length} product{results.length !== 1 ? 's' : ''}
              </p>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="results-grid">
                {results.map((product) => (
                  <ProductCard key={product.id} product={product} />
                ))}
              </div>
            </>
          ) : (
            <div className="text-center py-12" data-testid="no-results">
              <p className="text-stone-500">No products found for "{query}"</p>
            </div>
          )
        ) : (
          <div className="text-center py-12" data-testid="no-search">
            <p className="text-stone-500">Enter a search term to find products</p>
          </div>
        )}
      </div>
    </div>
  );
};